export const formatDate = (d) => (d ? new Date(d).toLocaleDateString('th-TH') : '-');
export const formatDateTime = (d) => (d ? new Date(d).toLocaleString('th-TH') : '-');
export const formatValue = (v) => (v == null ? '-' : Number(v).toLocaleString('th-TH', { minimumFractionDigits: 2 }));
